module.exports = __webpack_public_path__ + "static/media/disinfect.fbe6122e.png";